import { ListColumn, ListColumnAlignment } from '@/interfaces'
import { computed } from 'vue'

const offeredPackagesCols = computed<ListColumn[]>(() => {
  return [
    {
      name: 'package-name',
      title: 'content-package-name',
      width: 31,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 1,
      priority: 2,
      expand: true
    },
    {
      name: 'content-creator-name',
      title: 'content-creator-name',
      width: 32,
      alignment: ListColumnAlignment.Center,
      sortable: false,
      position: 2,
      priority: 4
    },
    {
      name: 'sent-at',
      title: 'sent-at',
      width: 12,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 4,
      priority: 5
    },
    {
      name: 'status',
      title: 'status',
      width: 16,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 3,
      priority: 3
    },
    {
      name: 'accept-action',
      title: '',
      width: 5,
      alignment: ListColumnAlignment.Center,
      sortable: false,
      maxWidthInPx: '70px',
      position: 5,
      priority: 1
    },
    {
      name: 'actions',
      title: '',
      width: 5,
      alignment: ListColumnAlignment.Center,
      sortable: false,
      maxWidthInPx: '70px',
      position: 6,
      priority: 0
    }
  ]
})

export default offeredPackagesCols
